/**
 * @GestionalePD Reset user password by user fiscal code page UI
 */
import React, { useState } from 'react';
import { styled, Grid, Box, Typography, Container, Stack, useMediaQuery } from '@mui/material';
import {
  ArrowBackIosNew as ArrowBackIosNewIcon,
  CheckCircleOutline as CheckCircleOutlineIcon,
} from '@mui/icons-material';
import { Unstable_Popup as BasePopup } from '@mui/base/Unstable_Popup';
import { Link } from 'react-router-dom';
//-------------------------------------------------------------
import { PopupSuccessBody, PopupErrorBody, POPUP_DURATION_SUCCESS, POPUP_DURATION_ERROR } from '../utils/popUpStyles';
import { StyledRegistrationCard } from '../utils/StyledElements';
import { DefaultContainedButton } from '../utils/Buttons';
import { CustomTextField } from '../utils/StyledInputs';
import { HttpErrorHandler } from '../utils/ErrorHandler';
import API from '../api';

// Custom popup style
const Popup = styled(BasePopup)`
  z-index: 1400;
`;

/**
 * @returns Forget password page UI
 */
export default function ResetForgetPasswordPage() {
  const is600Screen = useMediaQuery('(min-width: 600px)');

  const [resetFiscalCode, setResetFiscalCode] = useState('');
  const [pageIndex, setPageIndex] = useState(1);

  // Popup
  const [anchor, setAnchor] = useState(null);
  const [open, setOpen] = useState(false);
  const [popUpText, setPopUpText] = useState('');
  const [popupSuccess, setPopupSuccess] = useState(true);
  const [responseMessage, setResponseMessage] = useState('');

  // popup handler
  const showPopup = (success, text) => {
    setPopupSuccess(success);
    setOpen(true);

    if (text) {
      setPopUpText(text);
    }

    setTimeout(
      () => {
        setOpen(false);
      },
      success ? POPUP_DURATION_SUCCESS : POPUP_DURATION_ERROR
    );
  };

  // request for resetting password link by user e-mail
  const onForgetPasswordClick = (event) => {
    event.preventDefault();
    API.patch('/passwordforgotten', { fiscal_code: resetFiscalCode })
      .then((response) => {
        showPopup(true, 'Richiesta inviata con successo');
        setResponseMessage(response.data.message);
        setPageIndex(2);
      })
      .catch((error) => {
        HttpErrorHandler(error, setPopUpText);
        showPopup(false);
      });
  };

  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ width: '100vw', height: '100vh' }}
      className="default-bg"
    >
      <StyledRegistrationCard is600Screen={is600Screen}>
        {/* reset fiscal code form section */}
        {pageIndex === 1 && (
          <Stack direction="column" spacing={3} justifyContent="center" alignItems="center">
            <Box width="125px" sx={{ paddingBottom: '20px' }}>
              <Box component="img" width="100%" src="assets/images/img/logopd.png" alt="Logo PD" />
            </Box>

            <Typography variant="h3" sx={{ marginTop: '15px', textAlign: 'center' }}>
              Hai dimenticato la Password?
            </Typography>

            <Typography width="80%" sx={{ textAlign: 'center' }}>
              Inserisci il codice fiscale associato al tuo account e riceverai un link per reimpostare la password
              all'indirizzo email di regstrazione
            </Typography>

            <form style={{ width: '100%' }} method="post" onSubmit={onForgetPasswordClick}>
              <Grid container justifyContent="center" alignItems="center" spacing={2}>
                {/* Reset E-mail  */}
                <Grid item xs={11} md={9}>
                  <CustomTextField
                    fullWidth
                    label="Codice Fiscale"
                    onChange={(e) => setResetFiscalCode(e.currentTarget.value)}
                  />
                </Grid>

                {/* Submit Button  */}
                <Grid item xs={11} md={9}>
                  <DefaultContainedButton
                    fullWidth
                    customStyles={{
                      marginTop: '10px',
                      height: '40px',
                      width: '100%',
                    }}
                    type="submit"
                  >
                    Invia
                  </DefaultContainedButton>
                </Grid>
              </Grid>
            </form>
          </Stack>
        )}

        {/* Request sended success message */}
        {pageIndex === 2 && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CheckCircleOutlineIcon sx={{ fontSize: '5em', color: 'green' }} />

            <Typography variant="h5" sx={{ padding: '0 12px' }}>
              {`${responseMessage}. Controlla la tua casella di posta e segui le indicazioni per reimpostare la
              password`}
            </Typography>
          </Box>
        )}

        {/* Redirect To login page  */}
        <Link style={{ textDecoration: 'none', paddingTop: 4 }} to={'/'}>
          <ArrowBackIosNewIcon sx={{ fontSize: '.8em', paddingTop: '2px' }} /> Torna alla pagina login
        </Link>
      </StyledRegistrationCard>

      {/* Popup style */}
      <Container ref={setAnchor}>
        <Popup anchor={anchor} open={open} >
          {popupSuccess ? (
            <PopupSuccessBody sx={{ whiteSpace: 'pre-line' }}>{popUpText}</PopupSuccessBody>
          ) : (
            <PopupErrorBody>{popUpText}</PopupErrorBody>
          )}
        </Popup>
      </Container>
    </Stack>
  );
}
